<template>
  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form
        :inline="true"
        size="small"
        :model="formInline"
        class="demo-form-inline"
      >
        <el-form-item label="救援服务名称">
          <el-input
            placeholder="请输入救援服务名称"
            v-model="formInline.search"
          >
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="getData"
            >查询</el-button
          >
        </el-form-item>
      </el-form>
    </div>

    <div class="common-level-rail">
      <el-button
        size="small"
        icon="el-icon-plus"
        type="primary"
        @click="addClick"
        >添加救援服务</el-button
      >
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table
            size="small"
            :data="tableData"
            border
            style="width: 100%"
            v-loading="loading"
          >
            <el-table-column
              prop="user.nickName"
              label="维修小工"
            ></el-table-column>

            <el-table-column prop="name" label="救援服务"></el-table-column>
            <el-table-column
              prop="rescueServiceCatalog.name"
              label="类目"
            ></el-table-column>
            <el-table-column prop="phone" label="电话"></el-table-column>
            <el-table-column prop="address" label="地址"></el-table-column>
            <el-table-column label="logo">
              <template slot-scope="scope">
                <img
                  v-if="scope.row.image && scope.row.image.length > 0"
                  :src="scope.row.image[0].file_path"
                  alt="logo"
                  style="width: 100px; height: auto;"
                />
              </template>
            </el-table-column>

            <el-table-column prop="genius" label="擅长"></el-table-column>
            <el-table-column prop="grade" label="评级"></el-table-column>

            <el-table-column label="审核状态">
              <template slot-scope="scope">
                <div v-if="scope.row.status == 0">未审核</div>
                <div v-if="scope.row.status == 1">审核通过</div>
                <div v-if="scope.row.status == 2">审核未通过</div>
              </template>
            </el-table-column>

            <el-table-column
              prop="reject_val"
              label="审核不通过原因"
            ></el-table-column>

            <el-table-column prop="sort" label="排序"></el-table-column>
            <el-table-column
              prop="create_time"
              label="创建时间"
              width="150"
            ></el-table-column>
            <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.status == 0"
                  @click="passClick(scope.row)"
                  type="text"
                  size="small"
                  >审核</el-button
                >
                <el-button
                  v-if="scope.row.status == 0"
                  @click="nopassClick(scope.row)"
                  type="text"
                  size="small"
                  >审核不通过</el-button
                >
                <el-button
                  @click="editClick(scope.row)"
                  type="text"
                  size="small"
                  >编辑</el-button
                >
                <el-button
                  @click="deleteClick(scope.row)"
                  type="text"
                  size="small"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>

    <Add :open_add="open_add" v-if="open_add" @close="closeAdd"></Add>
    <Edit
      :open_add="open_edit"
      :rescue_service_id="rescue_service_id"
      v-if="open_edit"
      @close="closeEdit"
    ></Edit>

    <el-dialog
      style="text-align: center"
      title="设置标题"
      :visible.sync="dialogVisible"
      @close="dialogFormVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :append-to-body="true"
    >
    </el-dialog>
  </div>
</template>

<script>
import Rescue_serviceApi from "@/api/rescue_service.js";
import Add from "./part/add.vue";
import Edit from "./part/edit.vue";

export default {
  components: {
    Add,
    Edit
  },
  inject: ["reload"],
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索表单对象*/
      form: {},
      formInline: {
        search: ""
      },

      open_add: false,
      open_edit: false,
      rescue_service_id: "",
      dialogVisible: false
    };
  },
  created() {
    /*获取列表*/
    this.getTableList();
  },
  methods: {
    passClick(item) {
      //通过审核
      var self = this;
      var Params = {
        rescue_service_id: item.rescue_service_id,
        status: 1
      };
      Rescue_serviceApi.passCanel(Params, true)
        .then(data => {
          console.log(data);
          if (data.code == 1) {
            self.$message({
              type: "success",
              message: "审核成功"
            });
            self.getTableList();
            return false;
          }
        })
        .catch(error => {});
    },
    async nopassClick(item) {
      //不通过审核
      var self = this;
      const reject_val = await this.promptInput(
        "请输入不通过的原图",
        "请输入2-4个汉字"
      );

      var Params = {
        rescue_service_id: item.rescue_service_id,
        status: 2,
        reject_val: reject_val
      };
      Rescue_serviceApi.passCanel(Params, true)
        .then(data => {
          if (data.code == 1) {
            self.$message({
              type: "success",
              message: "审核成功"
            });
            self.getTableList();
            return false;
          }
        })
        .catch(error => {});
    },
    async promptInput(message, validation) {
      try {
        const { value } = await this.$prompt(message, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputErrorMessage: validation
        });
        return value.trim();
      } catch (e) {
        this.$message({
          type: "info",
          message: "取消输入"
        });
      }
    },
    dialogFormVisible() {
      this.dialogVisible = false;
    },
    setting(e) {
      //救援服务标题设置
      // this.categorya_id = e
      this.dialogVisible = true;
    },
    /*关闭添加*/
    closeAdd(e) {
      this.open_add = false;
      this.getTableList();
    },
    closeEdit(e) {
      this.open_edit = false;
      this.getTableList();
    },
    getData() {
      this.getTableList();
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      this.curPage = val;
      this.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = this.formInline;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      self.loading = true;
      Rescue_serviceApi.list(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {});
    },

    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.getTableList();
    },

    /*添加任务*/
    addClick() {
      this.open_add = true;
    },

    /*编辑活动*/
    editClick(row) {
      this.rescue_service_id = row.rescue_service_id;
      this.open_edit = true;
    },

    /*删除*/
    deleteClick(row) {
      let self = this;
      self
        .$confirm("此操作将永久删除该记录, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          Rescue_serviceApi.del(
            {
              rescue_service_id: row.rescue_service_id
            },
            true
          )
            .then(data => {
              if (data.code == 1) {
                self.$message({
                  message: "删除成功",
                  type: "success"
                });
                this.getTableList();
              } else {
                self.$message.error("错了哦，这是一条错误消息");
              }
            })
            .catch(error => {});
        })
        .catch(() => {});
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/rescue_service/index/index.vue